// extracted by mini-css-extract-plugin
module.exports = {"iconsize":"sendmoney_iconsize_2Bwrq","text":"sendmoney_text_1CLTZ","fare":"sendmoney_fare_1LN0k","cssA":"sendmoney_cssA_3LkdX"};